<template>
  <div>
    <!-- No record card::begin -->
    <div class="card card-dark-withbg" v-if="!loading && data.length == 0">
      <div class="card-body p-0">
        <div class="card-px text-center py-20 my-10">
          <h2 class="fs-2x fw-bolder mb-10" v-if="moduleName">
            {{ $t(moduleName) }}
          </h2>
          <p class="text-gray-400 fs-4 fw-bold">
            <template v-if="moduleSearch">
              {{ $t('list.noRecordInfoLine1ForSearch') }}
            </template>
            <template v-else>
              {{ $t('list.noRecordInfoLine1') }}
            </template>
          </p>
          <p class="text-gray-400 fs-4 fw-bold" v-if="moduleCreateEvent">
            {{ $t('list.noRecordInfoLine2') }}
          </p>
          <div
            @click="openCreateModal"
            v-if="moduleCreateEvent"
            class="btn btn-primary mt-10 btn-sm rounded-sm"
          >
            <i class="far fa-plus-circle"></i>{{ $t('list.addNew') }}
          </div>
          <div
            v-if="showFilterClearButton"
            @click="clearFilter"
            class="btn btn-danger mt-10 ml-3 btn-sm rounded-sm"
          >
            <i class="far fa-times-circle"></i>{{ $t('list.clearFilters') }}
          </div>
        </div>
      </div>
    </div>
    <!-- No record card::end -->

    <div class="list" v-else>
      <div class="list-header" :style="headerStyle">
        <div
          class="item"
          v-for="(head, hI) in header"
          :key="hI"
          :class="head.class"
        >
          <slot :name="`header.${head.value}`" :item="head">
            {{ head.text ? $t(head.text) : '' }}
          </slot>
        </div>
      </div>

      <div class="loading" v-if="loading">
        <div class="loading_line_wrapper">
          <div class="loading_line">
            <div class="loading_line_inner loading_line_inner--1"></div>
            <div class="loading_line_inner loading_line_inner--2"></div>
          </div>
        </div>
        <span
          class="text font-size-md font-weight-bold text-muted p-2"
          v-if="data.length <= 0"
          >{{ $t('global.loadingItems') }}</span
        >
      </div>

      <Card v-else>
        <!-- <perfect-scrollbar class="pr-5 mr-n5 scroll position-relative"
                           :style="`max-height: ${scrollHeight};`"> -->
        <div class="list-content">
          <div v-for="(item, index) in data">
            <div class="item" :style="headerStyle">
              <div
                class="field"
                v-for="(head, dI) in header"
                :key="`${dI}${index}`"
                :class="head.class"
              >
                <template v-if="!head.copyField">
                  <router-link
                    v-if="detailUrl && detailUrl != '' && head.clicked"
                    :to="`${detailUrl}/${item.id}`"
                    class="rowLink"
                  >
                    <slot :name="`item.${head.value}`" :item="item">
                      {{
                        item[head.value]
                          ? $customFunctions.controlSpace(item[head.value])
                          : 'N/A'
                      }}
                    </slot>
                  </router-link>

                  <!-- slot will work if default -->
                  <span
                    :class="{ 'cursor-pointer': head.clicked }"
                    @click="clickField(item, head)"
                    v-else
                  >
                    <slot :name="`item.${head.value}`" :item="item">
                      {{
                        item[head.value]
                          ? $customFunctions.controlSpace(item[head.value])
                          : 'N/A'
                      }}
                    </slot>
                  </span>
                </template>
                <!-- copyField will work if true -->
                <CopyButtonLabel
                  v-else
                  :value="item[head.value] ? item[head.value] : 'N/A'"
                >
                  <slot :name="`item.${head.value}`" :item="item"></slot>
                </CopyButtonLabel>
              </div>
            </div>

            <slot
              name="subRow"
              :item="item"
              :selectedItemId="selectedItemId"
              :openNewItem="openNewItem"
            ></slot>
          </div>

          <span
            v-if="data.length <= 0 && !loading"
            class="text-center font-size-md font-weight-bold text-muted p-1"
            >{{ $t('global.noData') }}</span
          >
        </div>
      </Card>
    </div>
    <CustomPagination
      v-if="
        !loading &&
        data.length > 0 &&
        pagination &&
        pagination.constructor === Object &&
        Object.keys(pagination).length > 0
      "
      :page="pagination.current_page"
      :totalPages="pagination.total_pages"
      :totalItems="pagination.total"
      @changePage="changePage"
    />
  </div>
</template>

<script>
// Utils
import EventBus from '@/event-bus'

export default {
  name: 'List',
  props: {
    header: Array,
    data: Array,
    pagination: Object,
    loading: Boolean,
    scrollHeight: {
      type: String,
      default: '100%',
    },
    detailUrl: '',
    moduleName: '',
    moduleCreateEvent: '',
    moduleSearch: '',
    selectedItemId: '',
    openNewItem: {
      type: Boolean,
      default: false,
    },
    showFilterClearButton: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    headerStyle() {
      if (!this.header) return

      let mappingHeader = this.header
        .map((item) => {
          return item.size ? item.size : '1fr'
        })
        .join(' ')

      return {
        gridTemplateColumns: mappingHeader,
      }
    },
  },
  methods: {
    changePage(value) {
      this.$emit('updatePage', { current_page: value })
    },
    clickField(item, head) {
      if (!head.clicked) return false

      this.$emit(`click`, item, head.value)
    },
    openCreateModal() {
      EventBus.$emit(this.moduleCreateEvent, true)
    },
    clearFilter() {
      this.$emit('clearFilter', true)
    },
  },
}
</script>

<style lang="scss">
.list {
  .loading {
    width: 100%;
    height: 100%;

    .text {
      display: block;
      text-align: center;
    }

    .loading_line_wrapper {
      background: #fff;

      .loading_line {
        position: relative;
        width: 100%;
        height: 3px;
        transform-origin: 100% 0%;
        animation: kf_loading_line 1.5s cubic-bezier(0.645, 0.045, 0.355, 1) 0s
          infinite;

        .loading_line_inner {
          position: absolute;
          top: 0px;
          left: 0px;
          bottom: auto;
          right: auto;
          width: 100%;
          height: 100%;
          background: #00baf2;
          transform-origin: 0% 0%;
        }

        .loading_line_inner--1 {
          opacity: 0; //change for inner line opacity, currently 0/hidden
          animation: kf_loading_line_inner--1 1.5s
            cubic-bezier(0.645, 0.045, 0.355, 1) 0s infinite;
        }

        .loading_line_inner--2 {
          opacity: 1;
          animation: kf_loading_line_inner--2 1.5s
            cubic-bezier(0.645, 0.045, 0.355, 1) 0s infinite;
        }
      }
    }
  }

  & .list-header,
  & .list-content {
    display: grid;

    & .item {
      display: grid;
      align-items: center;
    }
  }

  .list-header {
    padding: 20px 0px 20px 20px;

    .item {
      font-size: 12px;
      line-height: 18px;
      font-weight: 600;
      letter-spacing: 0.03em;
      color: #b5b5c3;
      padding-right: 20px;

      &:last-child {
        padding-right: 0px;
      }
    }
  }

  .list-content {
    .item {
      border-bottom: 1px solid #ebedf2;
      padding: 20px 0px 20px 20px;

      .field {
        font-weight: 600;
        font-size: 13px;
        line-height: 21px;
        color: #464e5f;
        padding-right: 20px;

        .rowLink {
          color: #464e5f;
        }

        &:last-child {
          padding-right: 0px;
        }

        p {
          font-weight: 500;
          font-size: 12px;
          line-height: 21px;
          color: #b5b5c3;
        }

        .link {
          color: #464e5f;

          &:hover {
            color: #3699ff;
          }
        }

        .icon {
          font-weight: normal;
          font-size: 20px;
          line-height: 24px;
          color: #00baf2;
          border: 1px solid rgba(181, 181, 195, 0.3);
          border-radius: 6px;
          padding: 9px 12px;
        }

        .icon2 {
          font-size: 20px;
          line-height: 24px;
          color: #00baf2;
          border: 1px solid rgba(181, 181, 195, 0.3);
          border-radius: 6px;
          padding: 9px 12px;
        }
      }
    }
  }

  .card-body {
    padding: 0 !important;
  }
}

@keyframes kf_loading_line {
  0% {
    transform: scaleX(1);
  }
  50% {
    transform: scaleX(1);
  }
  100% {
    transform: scaleX(0);
  }
}

@keyframes kf_loading_line_inner--1 {
  0% {
    transform: scaleX(0);
  }
  25% {
    transform: scaleX(1);
  }
  100% {
    transform: scaleX(1);
  }
}

@keyframes kf_loading_line_inner--2 {
  0% {
    transform: scaleX(0);
  }
  25% {
    transform: scaleX(0);
  }
  50% {
    transform: scaleX(1);
  }
  100% {
    transform: scaleX(1);
  }
}

@media only screen and (max-width: 768px) {
  .list {
    & .list-header,
    & .list-content {
      display: block;

      & .item {
        display: block;
      }
    }
    .list-content {
      .item {
        .field {
          padding-bottom: 10px;
        }
      }
    }
  }
}
</style>
